// extracted by mini-css-extract-plugin
module.exports = {"text":"bodyCopySkins-largeOnWide-text-4cf15acb"};